<!--
    Formulario de llegada de una reserva pagada, al que se entra desde el link
    del correo sin login: /llegada/:idreserva/:token

    Qué formulario toca depende del modelo del anfitrión, y eso lo sabe el
    backend, así que esta página consulta primero y después muestra uno de los
    dos:

      · LlegadaCheckin  → motivo, universidad, vuelo y hora (huésped); quién
                          recibe, teléfono y acceso (anfitrión).
      · LlegadaContacto → los dos cargan WhatsApp, correo y un mensaje, y al
                          completarse se intercambian los contactos.

    La respuesta se le pasa al hijo por `precargado` para no pedir dos veces lo
    mismo. Si el link es inválido o vencido, el error se muestra acá y no se
    llega a montar ningún formulario.
-->
<template>
    <div>
        <HyFLoader v-if="loading" />

        <div v-else-if="error" class="llegada-error">
            <p>{{ error }}</p>
        </div>

        <component v-else :is="formulario" :precargado="datos" />
    </div>
</template>

<script>
import axios from 'axios';
import LlegadaCheckin from '@/pages/General/LlegadaCheckin';
import LlegadaContacto from '@/pages/General/LlegadaContacto';
import HyFLoader from '@/components/Loader/HyFLoader.vue';

export default {
    name: 'Llegada',

    components: {
        LlegadaCheckin,
        LlegadaContacto,
        HyFLoader,
    },

    data() {
        return {
            loading: true,
            error: null,
            datos: null,
        };
    },

    computed: {
        idreserva() {
            return this.$route.params.idreserva;
        },

        token() {
            return this.$route.params.token;
        },

        /**
         * El backend manda `flow: 'contacto'` solo en ese flujo; sin el dato
         * —una respuesta vieja, por ejemplo— va el de check-in, que es el que
         * está desplegado.
         */
        formulario() {
            return this.datos && this.datos.flow === 'contacto'
                ? 'LlegadaContacto'
                : 'LlegadaCheckin';
        },
    },

    created() {
        axios
            .get(`${process.env.VUE_APP_API_URL}arrival/${this.idreserva}/${this.token}`)
            .then(({ data }) => {
                this.datos = data;
            })
            .catch(() => {
                this.error = this.$t('arrival.error-invalid');
            })
            .finally(() => {
                this.loading = false;
            });
    },
};
</script>

<style scoped lang="scss">
.llegada-error {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 24px;
    text-align: center;
}
</style>
